import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IS_PUBLIC_API } from './../../vass-core/utils/is-public-api- context';
import { TRANSLASTION_TIMESTAMP_KEY, TRANSLATION_OBJECT_KEY } from './constants';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    const remoteTranslation$ = this.getRemoteTranslation(
      lang,
      this.getTranslationCachedDate(lang),
    );
    const cachedTranslation$ = this.getCachedTranslation(lang);
    const fileTranslation$ = this.getFileTranslation(lang);

    return forkJoin(fileTranslation$, cachedTranslation$, remoteTranslation$).pipe(
      map(([file, cached, remote]) => ({ ...file, ...cached, ...remote })),
      catchError(() => of({})),
    );
  }

  private getRemoteTranslation(lang: string, timestamp?: string | number) {
    const url = `${environment.apiBase}/i18n/${environment.api_version.i18n}/translations/${lang}`;

    let params = new HttpParams();
    params = params.append('channel', 'web');
    params = params.append('project', 'hipotecas');

    if (!!timestamp && !isNaN(+timestamp)) {
      params = params.append('fromDate', String(timestamp));
    }

    return this.http
      .get<any>(url, {
        params,
        context: new HttpContext().set(IS_PUBLIC_API, true),
      })
      .pipe(
        map((translation) => {
          if (Object.keys(translation).length === 0) {
            throw new Error('empty object');
          }

          localStorage.setItem(
            `${TRANSLATION_OBJECT_KEY}${lang}`,
            JSON.stringify(translation),
          );
          localStorage.setItem(
            `${TRANSLASTION_TIMESTAMP_KEY}${lang}`,
            String(new Date().getTime()),
          );

          return translation;
        }),
        catchError(() => of({})),
      );
  }

  private getFileTranslation(lang: string) {
    const url = `./assets/i18n/${lang}.json`;

    return this.http.get<any>(url).pipe(
      map((result) => result),
      catchError(() => of({})),
    );
  }

  private getCachedTranslation(lang: string) {
    return of(JSON.parse(localStorage.getItem(`${TRANSLATION_OBJECT_KEY}${lang}`))).pipe(
      map((result) => {
        if (!result) {
          throw new Error('cant retrieve cached data');
        }

        return result;
      }),
      catchError(() => of({})),
    );
  }

  private getTranslationCachedDate(lang) {
    return JSON.parse(localStorage.getItem(`${TRANSLASTION_TIMESTAMP_KEY}${lang}`));
  }
}
